import { request } from "@/request/request";
export default {
  // 获取作文
  compositionGetAnswer(data) {
    return request({
      url: "/composition-answer/getAnswer",
      method: "get",
      data,
    });
  },

  // 提交作文
  compositionSubmitAnswer(data) {
    return request({
      url: "/composition-answer/submitAnswer",
      method: "post",
      data,
    });
  },
};
